import { api } from '@/lib/api'
import { defaultPaginationMeta, parseMasterCatalogResponse } from '@/lib/api/masterCatalog'

/** @typedef {import('@/types/api').Supplier} Supplier */

/**
 * @param {Record<string, unknown>} [params]
 * @returns {Promise<{ items: Supplier[], meta: import('@/types/api').PaginationMeta }>}
 */
export async function fetchSuppliersPage(params = {}) {
  const { data } = await api.get('/masters/suppliers', { params })
  const parsed = parseMasterCatalogResponse(data, 'suppliers')
  return {
    items: parsed.items,
    meta: defaultPaginationMeta(parsed.meta ?? {}),
  }
}

/**
 * @param {Record<string, unknown>} [params]
 * @returns {Promise<Supplier[]>}
 */
export async function fetchSuppliersList(params = {}) {
  const { data } = await api.get('/masters/suppliers', { params })
  return data.data.suppliers
}

/**
 * @returns {Promise<Supplier[]>}
 */
export async function fetchSuppliers() {
  return fetchSuppliersList()
}

/**
 * @param {Partial<Supplier>} payload
 * @returns {Promise<Supplier>}
 */
export async function createSupplier(payload) {
  const { data } = await api.post('/masters/suppliers', payload)
  return data.data.supplier
}

/**
 * @param {number} supplierId
 * @param {Partial<Supplier>} payload
 * @returns {Promise<Supplier>}
 */
export async function updateSupplier(supplierId, payload) {
  const { data } = await api.put(`/masters/suppliers/${supplierId}`, payload)
  return data.data.supplier
}
